import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class DayRoute extends Route {
  @service("ember-store")
  store
  // model(params){
  // let planbook = this.modelFor('planbook')
  // console.log('planbook', planbook)
  // return Ember.RSVP.hash({
  //   planbook: planbook
  // })
  //   return this.modelFor('planbook')
  // },
}
